/** Recency + frequency memory for the palette (per browser). Things JP touches daily surface first. */
const KEY = 'cortex.usage';
type Usage = Record<string, { n: number; last: number }>;

function load(): Usage {
  try {
    return JSON.parse(localStorage.getItem(KEY) ?? '{}') as Usage;
  } catch {
    return {};
  }
}

export function recordUse(id: string): void {
  const u = load();
  const cur = u[id] ?? { n: 0, last: 0 };
  u[id] = { n: cur.n + 1, last: Date.now() };
  // Keep it bounded.
  const entries = Object.entries(u).sort((a, b) => b[1].last - a[1].last).slice(0, 400);
  localStorage.setItem(KEY, JSON.stringify(Object.fromEntries(entries)));
}

/** 0..1-ish boost: frequency with recency decay over ~30 days. */
export function usageBoost(id: string): number {
  const e = load()[id];
  if (!e) return 0;
  const ageDays = (Date.now() - e.last) / 86_400_000;
  return Math.min(1, Math.log2(1 + e.n) / 4) * Math.exp(-ageDays / 30);
}

export function recentIds(limit = 8): string[] {
  return Object.entries(load())
    .sort((a, b) => b[1].last - a[1].last)
    .slice(0, limit)
    .map(([id]) => id);
}
